import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    if (location.pathname !== '/') {
      window.location.href = `/#${sectionId}`;
    } else {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <nav className={`fixed w-full z-50 transition-all duration-300 ${isScrolled ? 'bg-black/60 backdrop-blur-md shadow-xl' : 'bg-transparent'}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16 md:h-20">
          <Link to="/" className="text-white font-serif text-xl md:text-2xl font-semibold hover:text-accent transition-smooth flex items-center gap-3">
            <img 
              src="/main logo -Photoroom.png" 
              alt="Jesse Camarena Photography"
              className="h-12 md:h-16 w-auto object-contain"
            />
            <span className="hidden sm:inline">Jesse Camarena</span>
          </Link>

          {/* Desktop Menu */}
          <div className="hidden md:flex space-x-8">
            <button onClick={() => scrollToSection('home')} className="text-white hover:text-accent transition-smooth">
              Home
            </button>
            <Link to="/galleries" className="text-white hover:text-accent transition-smooth">
              Gallery
            </Link>
            <Link to="/pricing" className="text-white hover:text-accent transition-smooth">
              Pricing
            </Link>
            <Link to="/contact" className="text-white hover:text-accent transition-smooth">
              Contact
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button 
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden text-white focus:outline-none"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              {isMobileMenuOpen ? (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-black/90 backdrop-blur-md border-t border-white/10">
          <div className="px-4 py-4 space-y-3">
            <button onClick={() => scrollToSection('home')} className="block w-full text-left text-white hover:text-accent transition-smooth py-2">
              Home
            </button>
            <Link to="/galleries" onClick={() => setIsMobileMenuOpen(false)} className="block text-white hover:text-accent transition-smooth py-2">
              Gallery
            </Link>
            <Link to="/pricing" onClick={() => setIsMobileMenuOpen(false)} className="block text-white hover:text-accent transition-smooth py-2">
              Pricing
            </Link>
            <Link to="/contact" onClick={() => setIsMobileMenuOpen(false)} className="block text-white hover:text-accent transition-smooth py-2">
              Contact
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
